<script setup lang="ts">
import { useRouter } from 'vue-router'

interface Props {
  title?: string
  subtitle?: string
  buttonText?: string
  buttonLink?: string
  mobileButtonText?: string
}

const props = withDefaults(defineProps<Props>(), {
  title: '让工作过程自己变成台账',
  subtitle: '免费试用，立即体验"过程即台账"',
  buttonText: '免费试用',
  buttonLink: '/login',
  mobileButtonText: '立即免费试用',
})

const router = useRouter()

function handleCtaClick() {
  router.push(props.buttonLink)
}
</script>

<template>
  <section
    id="cta"
    class="relative py-16 md:py-20"
    style="background: linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%)"
  >
    <div class="mx-auto max-w-[800px] px-6 text-center">
      <h2 class="mb-4 text-2xl font-semibold text-white md:text-3xl">
        {{ title }}
      </h2>
      <p class="mb-8 text-base text-white/80 md:text-lg">
        {{ subtitle }}
      </p>

      <!-- 桌面端按钮 -->
      <button
        class="hidden rounded-full bg-white px-10 py-4 text-base font-medium text-indigo-600 transition-all duration-200 hover:bg-white/90 hover:shadow-lg md:inline-block"
        @click="handleCtaClick"
      >
        {{ buttonText }}
      </button>
    </div>

    <!-- 移动端固定底部 CTA -->
    <div class="fixed bottom-4 left-4 right-4 z-40 md:hidden">
      <button
        class="w-full rounded-full bg-white py-3.5 text-base font-medium text-indigo-600 shadow-lg"
        @click="handleCtaClick"
      >
        {{ mobileButtonText }}
      </button>
    </div>
  </section>
</template>
